import "./termsPage.css";

const TermsPage = () => (
  <main className="legal-section">
    <div className="legal-container">
      <h1 className="legal-title">Terms of Service</h1>
      <p className="legal-updated">Last updated: January 2025</p>

      <section className="legal-block">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using the TUT ReportHub system, you agree to be bound
          by these Terms of Service. If you do not agree to these terms, you may
          not use this platform. This system is intended solely for authorised
          Tshwane University of Technology (TUT) staff members including
          lecturers, reviewers, lead reviewers, and administrators.
        </p>
      </section>

      <section className="legal-block">
        <h2>2. Authorised Use</h2>
        <p>
          Access to TUT ReportHub is restricted to authorised users with valid
          institutional credentials. You agree to:
        </p>
        <ul>
          <li>Use the system only for its intended purpose of managing and reviewing weekly lecturer reports.</li>
          <li>Keep your login credentials confidential and not share them with any other person.</li>
          <li>Notify the system administrator immediately if you suspect unauthorised use of your account.</li>
          <li>Submit accurate and truthful information in all reports and forms.</li>
        </ul>
      </section>

      <section className="legal-block">
        <h2>3. Report Submission Obligations</h2>
        <p>
          Lecturers are required to submit weekly reports by the specified
          deadline (Saturday at 21:59). Late or missed submissions are recorded
          and may affect your performance records. You are responsible for
          ensuring that all submitted information is accurate, complete, and
          submitted within the required timeframe.
        </p>
      </section>

      <section className="legal-block">
        <h2>4. Data Accuracy</h2>
        <p>
          Users are responsible for the accuracy and integrity of the data they
          submit through the system. Submission of false, misleading, or
          fraudulent information is strictly prohibited and may result in
          disciplinary action in accordance with TUT institutional policies.
        </p>
      </section>

      <section className="legal-block">
        <h2>5. Intellectual Property</h2>
        <p>
          All content, design, and functionality of the TUT ReportHub platform
          are the intellectual property of Tshwane University of Technology.
          Unauthorised reproduction, distribution, or modification of any part
          of this system is prohibited.
        </p>
      </section>

      <section className="legal-block">
        <h2>6. System Availability</h2>
        <p>
          TUT ReportHub is provided on an "as available" basis. While we strive
          to maintain continuous availability, the university does not guarantee
          uninterrupted access and shall not be liable for any downtime,
          disruption, or data loss due to system maintenance or unforeseen
          circumstances.
        </p>
      </section>

      <section className="legal-block">
        <h2>7. Account Termination</h2>
        <p>
          The system administrator reserves the right to deactivate or terminate
          any account that is found to be in violation of these Terms of Service
          or institutional policies, without prior notice.
        </p>
      </section>

      <section className="legal-block">
        <h2>8. Changes to Terms</h2>
        <p>
          TUT ReportHub reserves the right to update these Terms of Service at
          any time. Continued use of the system after changes are posted
          constitutes acceptance of the revised terms.
        </p>
      </section>

      <section className="legal-block">
        <h2>9. Contact</h2>
        <p>
          If you have any questions regarding these Terms of Service, please
          contact the system administrator via the{" "}
          <a href="/contact-us">Contact Us</a> page.
        </p>
      </section>
    </div>
  </main>
);

export default TermsPage;
